module.exports = __webpack_public_path__ + "static/media/ad1.8b3bc42b.png";